<template>
    <CodiceFeanorView tool-module="jsonSign" />
</template>

<script setup>
import CodiceFeanorView from "../CodiceFeanorView.vue";
</script>
